{
  "header": {
    "title": "Path Master",
    "description": "Manage evacuation network Path details for PSS."
  },
  "owners": ["STU", "Transmission Licensee", "Distribution Licensee"],
  "districts": ["Ahmednagar", "Kolhapur", "Nashik", "Amravati", "Mumbai"],
  "links": [
    { "code": "LNK-001", "name": "Ahmednagar Feeder - 1", "pssCode": "PSS-001" },
    { "code": "LNK-002", "name": "Ahmednagar Feeder - 2", "pssCode": "PSS-001" },
    { "code": "LNK-003", "name": "Ahmednagar Feeder - 3", "pssCode": "PSS-001" },
    { "code": "LNK-004", "name": "Kolhapur Feeder - 1", "pssCode": "PSS-004" },
    { "code": "LNK-005", "name": "Nashik Feeder - 1", "pssCode": "PSS-007" },
    { "code": "LNK-006", "name": "Amravati Feeder - 1", "pssCode": "PSS-008" }
  ],
  "paths": [
    {
      "id": "PT001", "name": "Ahmednagar Regional Corridor", "code": "PT-ANR-01", "description": "Evacuation corridor from Ahmednagar PSS to the regional grid.", "pssCode": "PSS-001", "owner": "STU", "districts": ["Ahmednagar"], "linkCodes": ["LNK-001", "LNK-002", "LNK-003"], "contractIds": [1, 2, 3], "purpose": "Curtailment, Moderation of Curtailment", "usedForDataSharing": true, "effectiveFrom": "2026-01-01", "effectiveTo": "", "remarks": "Primary corridor", "status": "Active"
    },
    {
      "id": "PT002", "name": "Kolhapur Regional Corridor", "code": "PT-KOL-01", "description": "Evacuation corridor serving Kolhapur PSS.", "pssCode": "PSS-004", "owner": "Transmission Licensee", "districts": ["Kolhapur"], "linkCodes": ["LNK-004"], "contractIds": [4], "purpose": "Curtailment", "usedForDataSharing": false, "effectiveFrom": "2026-02-01", "effectiveTo": "", "remarks": "", "status": "Active"
    },
    {
      "id": "PT003", "name": "Nashik Regional Corridor", "code": "PT-NSK-01", "description": "Evacuation corridor serving Nashik PSS.", "pssCode": "PSS-007", "owner": "STU", "districts": ["Nashik"], "linkCodes": ["LNK-005"], "contractIds": [5], "purpose": "WRLDC WBES Data Sharing", "usedForDataSharing": true, "effectiveFrom": "2026-01-15", "effectiveTo": "", "remarks": "", "status": "Active"
    },
    {
      "id": "PT004", "name": "Amravati Regional Corridor", "code": "PT-AMR-01", "description": "Evacuation corridor serving Amravati PSS.", "pssCode": "PSS-008", "owner": "STU", "districts": ["Amravati"], "linkCodes": ["LNK-006"], "contractIds": [6], "purpose": "Curtailment", "usedForDataSharing": false, "effectiveFrom": "2026-03-01", "effectiveTo": "", "remarks": "", "status": "Active"
    }
  ]
}
